import request from '@/utils/request'

export function getTenderDocumentList (query) {
  return request({
    url: '/business/tenderDocument/list',
    method: 'get',
    params: query
  })
}

export function getInfo (id) {
  return request({
    url: '/business/tenderDocument/' + id,
    method: 'get'
  })
}

export function addTenderDocument(data) {
  return request({
    url: '/business/tenderDocument',
    method: 'post',
    data: data
  })
}

export function updateTenderDocument(data) {
  return request({
    url: '/business/tenderDocument',
    method: 'put',
    data: data
  })
}
export function updateTenderDocumentStatus(data) {
  return request({
    url: '/business/tenderDocument/updateStatus',
    method: 'put',
    data: data
  })
}

// 删除
export function delTenderDocument(id) {
  return request({
    url: '/business/tenderDocument/' + id,
    method: 'delete'
  })
}

// 下载标书
export function download(data) {
  return request({
    url: '/business/tenderDocument/export',
    method: 'post',
    data: data
  })
}

// 下载投标附件
export function downloadTenderAttachment(id) {
  return request({
    url: '/business/tenderDocument/downloadTenderAttachment/' + id,
    method: 'get'
  })
}
// 下载标书附件
export function downloadTenderDocAttachment(id) {
  return request({
    url: '/business/tenderDocument/downloadTenderDocAttachment/' + id,
    method: 'get'
  })
}
// 获取开标数据
export function getBidPeningList (id) {
  return request({
    url: '/business/tenderDocument/getBidPeningList/' + id,
    method: 'get'
  })
}

// 导出开标数据
export function exportBidPeningData(query) {
  return request({
    url: '/business/tenderDocument/exportBidPeningData',
    method: 'get',
    params: query
  })
}

// 导出所有开标数据
export function exportAllBidPeningData(query) {
  return request({
    url: '/business/tenderDocument/exportAllBidPeningData',
    method: 'get',
    params: query
  })
}

export function checkLinkPassword (data) {
  return request({
    url: '/business/tenderDocument/checkLinkPassword',
    method: 'get',
    params: data
  })
}

export function getCountByStatus () {
  return request({
    url: '/business/tenderDocument/getCountByStatus',
    method: 'get'
  })
}

export function getSubjectMatterCount (id) {
  return request({
    url: '/business/tenderDocument/getSubjectMatterCount/' + id,
    method: 'get'
  })
}

export function getTenderInfoCount (id) {
  return request({
    url: '/business/tenderDocument/getTenderInfoCount/' + id,
    method: 'get'
  })
}

// 下载导入模板
export function importTemplate() {
  return request({
    url: '/business/tenderDocument/importTemplate',
    method: 'get'
  })
}

// 更新截标时间
export function updateTenderDocumentSubDeadlineTime(data) {
  return request({
    url: '/business/tenderDocument/updateSubDeadlineTime',
    method: 'put',
    data: data
  })
}